import React from 'react';
import { SvgIcon } from '@agilize/components-core';
import { Routes } from './Routing.types';

export const routes: Routes[] = [
  {
    label: 'Início',
    icon: <SvgIcon src={`${process.env.APP_PATH}public/assets/icons/dashboard.svg`} height={40} width={40} fill="white" />,
    path: '/',
    exact: true,
    navigable: false,
  },
];
